import { render, staticRenderFns } from "./MessagePanel.vue?vue&type=template&id=6cfaabac&scoped=true&lang=pug"
import script from "./MessagePanel.vue?vue&type=script&lang=js"
export * from "./MessagePanel.vue?vue&type=script&lang=js"
import style0 from "./MessagePanel.vue?vue&type=style&index=0&id=6cfaabac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfaabac",
  null
  
)

export default component.exports